module.exports = __webpack_public_path__ + "static/img/zfjs.2361b58.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/itemImgs/zfjs.jpg
// module id = QH9W
// module chunks = 0